<template>
  <div>
  <my-request-layout
    :workflowGuid="registration.workflowGuid"
    :foundRequest="!!registration"
    :isLoading="isLoading"
    :myRequest="registration"
    :cancelRequest="cancelRequest"
    :paymentStatus="paymentStatus"

    useAuthorizedPayment
    :makePayment="makePayment"
    :authorizePayment="authorizePayment"
    :showPaymentAuthorizationStatus="registration.needsPaymentAuthorization"
  >
    <span slot="title"
      >Renew Affiliate: {{ registration.affiliateRequestData.name }}</span
    >

    <div slot="requestContent" v-if="registration.affiliateRequestData" class="mb-5">
      <renew-affiliate-request :registration="registration.affiliateRequestData"/>
    </div>
  </my-request-layout>
  <v-snackbar v-model="showErrorMessage" title color="error">
    {{ errorMessage }}
    <template v-slot:action="{ attrs }">
    <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
      Close
    </v-btn>
    </template>
  </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import MyRequestLayout from "@/components/Portal/MyRequest/MyRequestLayout.vue";
import RenewAffiliateRequest from "@/components/Portal/MyRequest/RenewAffiliateRequest.vue";

import workflowService from "@/services/portal/workflowService";

import { UserInfo } from "@/types/User";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";

export default Vue.extend({
  name: "MyRenewAffiliateequest",
  components: {
    MyRequestLayout,
    RenewAffiliateRequest,
  },
  data: function () {
    return {
      registration: Object as any,
      isLoading: false,
      paymentStatus: null,
      errorMessage: "",
      showErrorMessage: false,
    };
  },
  props: {
    workflowGuid: { type: String },
  },
  methods: {
    load() {
      this.isLoading = true;
      workflowService
        .getAffiliateRenewalRequestDetails(this.workflowGuid)
        .then((res) => {
          this.isLoading = false;
          this.registration = res;
        });
    },
    authorizePayment: function (paymentInfo: AuthorizeNetResponseData) {
      var req = {
        paymentInfo,
        personId: this.userInfo.personId,
        workflowGuid: this.registration.workflowGuid,
      };
      workflowService.submitAffiliateRenewalCCAuthorization(req).then((res) => {
        this.paymentStatus = res;
        this.load();
      });
    },
    makePayment: function (paymentInfo: AuthorizeNetResponseData) {
      var req = {
        paymentInfo,
        personId: this.userInfo.personId,
        workflowGuid: this.registration.workflowGuid,
      };
      workflowService.submitAffiliateRenewalCCPayment(req).then((res) => {
        if (res.error) {
          this.errorMessage = res.error;
          this.showErrorMessage = true;
        }
        else {
          this.paymentStatus = res;
        }

        this.load();
      });
    },
    cancelRequest: function () {
    },
  },
  created() {
    this.load();
  },
  watch: {
    workflowGuid: function (newValue) {
      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
